import React from 'react'
import { Progress, Toast } from 'antd-mobile'

import app from './src/app.js'
import canvasDrawer from './src/canvasDraw.js'

import OptionBar from '../../components/optionBar/optionBar.jsx'
import Menu from '../../components/menu/menu.jsx'

import './src/index.js'
import './webgl_render.less'

class WebglRender extends React.Component {

    state = {
        //是否显示进度条
        showloadingBar: true,
        //进度条数值
        loadingParcent: 0,
        /*hideZhankaiBt: false,*/

        ifDraw: false,

        //画笔相关
        colorList : ['#5271FF','#FF63B1','#ff0000','#35B72A','#000000'],
        colorIndex:2,
        colorItem:'#ff0000',

        tapList:[],
        tapIndex:0
    }


    handleLoadFail() {
        const _this = this
        Toast.fail('加载失败!', 1, () => {
            _this.props.history.push('/')
        });
    }

    loadFinish() {
        this.setState({
/*            zhankai: false,*/
            showloadingBar: false
        })
        window.appLoading = document.getElementById('appLoading')
        appLoading.style.display = 'none'
    }

    componentDidMount() {
        const _this = this
        app.reactDomComponent = this
        app.init(this.state.webglDom)
        app.loadMain()
        canvasDrawer.init(this.state.CanvasDom, this)
        console.log(app.groupLinkToMesh)
        let arr = []
        for(let i in app.groupLinkToMesh){
            app.groupLinkToMesh[i].oIndex = arr.length
            arr.push(app.groupLinkToMesh[i])
        }
        console.log(arr)

        this.setState({
            tapList:arr
        })
        app.tapComponent = this
    }

    //居中
    resetApp() {
        app.resetControl()
    }



    updataLoading(num) {
        this.setState({
            loadingParcent: num
        })
    }

    toggleIfDraw() {
        canvasDrawer.beginDraw(!this.state.ifDraw)
        this.setState({
            ifDraw: !this.state.ifDraw
        })
    }


    mouseSelectClick() {
        app.mouseSelectClick()
    }

    colorClick(item,index){
        this.setState({
            colorItem:item,
            colorIndex:index
        })
        return false
    }

    tapClick(item,index){
        console.log(item)
        this.setState({
            tapIndex:index
        })

        app.clickOption(item)
    }


    render() {
        const _this = this
        const { loadingParcent } = this.state;

        return (

            <div className='webgl-wrap'>
                <div className='screen'> 

                    <div className="webgl" id = 'webgl'>

                        <div ref = { el => this.state.webglDom = el } id = 'webglDom'></div>

                        <div className={this.state.showloadingBar?"progress-container":"progress-container hide"}>
                            <Progress percent={ loadingParcent } position="normal" unfilled={true} />
                            <p className ='loading-tip-text'>
                                {'正在加载资源'+loadingParcent+'%...'}
                            </p>
                        </div>

                        <canvas className = {this.state.ifDraw?'canvasDraw':'canvasDraw hide'} ref = { el => this.state.CanvasDom = el }></canvas>
                        
                        {/*<div className = {this.state.zhankai?'home-wrap hidden':'home-wrap'}>

                            <div className='home-tap'>

                                <div className='item resetCamera' onClick = {this.resetApp}></div>

                                <div 
                                    className={this.state.ifDraw?'item pencil active':'item pencil'}
                                    onClick = {this.toggleIfDraw.bind(this)}>
                                    <a>画笔</a>
                                </div>

                            </div>
                        </div>*/}

                        <OptionBar/>


                       {/* <div className ={this.state.ifDraw?'color-list':'hide'}>
                            {    
                                this.state.colorList?this.state.colorList.map((item,index) =>(
                                    <li key={index} className = {this.state.colorIndex === index?'active':null}
                                    onClick = {this.colorClick.bind(this,item,index)}
                                    style = {{'backgroundColor':item}}></li>
                                )):null
                            }   
                        </div>*/}

                        <div className ='tap-list'>
                            {    
                                this.state.tapList?this.state.tapList.map((item,index) =>(
                                    <li key={index} className = {this.state.tapIndex === index?'active':null}
                                    onClick = {this.tapClick.bind(this,item,index)}>
                                    {
                                        item.cnName
                                    }</li>
                                )):null
                            }   
                        </div>

                    </div>
                    
                </div>  
            </div>
        )
    }
}


export default WebglRender


// WEBPACK FOOTER //
// ./src/pages/webgl/webgl_render.jsx